export enum ModalType {
    Full,
    Rebet,
    Message,
    Center,
}
